import React, { useState, useEffect } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { ReactComponent as Back } from '../../images/back.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import base from '../../apis';
import MenuDropDown from '../../components/MenuDropDown/MenuDropDown';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { ReactComponent as TeamLogo } from '../../images/teamLogo.svg';
import { randomColorAndLighter } from '../../utils/functions';
import { AiOutlineCheck } from 'react-icons/ai';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { useCallback } from 'react';
import { officeLocations, sizeOptions } from '../../constants';

const filterOptions = [
  { value: 'All', label: 'All' },
  { value: 'Assigned', label: 'Assigned' },
  { value: 'Unassigned', label: 'Unassigned' },
];
const selectStyles = {
  container: (provided) => ({
    ...provided,
    width: '200px',
  }),
};

const selectStyles1 = {
  container: (provided) => ({
    ...provided,
    flex: 1,
  }),
};

function AssignOfficeToTeam() {
  const navigate = useNavigate();
  const { name } = useLocation().state;

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(filterOptions[0]);
  const [officeDetails, setOfficeDetails] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [confirmOpen, setconfirmOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const OFFICES = React.useRef([]);
  const TEAMS = React.useRef([]);
  const [CITIES, setCITIES] = useState([]);
  const [assignableTeams, setAssignableTeams] = useState({
    isLoading: false,
    data: [],
  });
  const [searchParams, setSearchParams] = useState({
    city: null,
    size: null,
    location: null,
    address: '',
  });
  const [teamsModalOpen, setTeamsModalOpen] = useState(false);
  const [teamToAssignTo, setTeamToAssignTo] = useState('');

  const getOffices = useCallback(
    (comp) => {
      setIsLoading(true);
      setSearchParams({ address: '', name: '', state: '', county: '' });
      setSelectedOption(filterOptions[0]);
      base
        .get(`/operations/companies/${comp || id}/`)
        .then(({ data }) => {
          setOfficeDetails(data);
          if (data) {
            OFFICES.current = data;
            const cities = data?.offices?.map((item) => item.city);
            setCITIES([...new Set(cities)].map((item) => ({ value: item, label: item })));
            if (data?.offices.length === 0) {
              toast.warn('No offices found');
            }
          }
        })
        .catch((err) => {
          toast.error('Error Loading Offices');
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [id]
  );

  useEffect(() => {
    getOffices();
  }, [getOffices]);

  const onEnterSearch = (e, option) => {
    if (option) {
      setSearchParams({ ...searchParams, [option]: e });
      return;
    }

    const { value, name } = e.target;
    setSearchParams((prev) => ({ ...prev, [name]: value }));
  };

  const onSearch = (e) => {
    e.preventDefault();
    const { city, size, location, name } = searchParams;
    if (!city?.value && !size?.value && !location && !name) {
      setOfficeDetails(OFFICES.current);
      return;
    }
    const filteredOffices = OFFICES.current.offices.filter((office, index) => {
      if (city?.value && office.city?.toLowerCase() !== city?.value?.toLowerCase()) {
        return false;
      }
      if (size?.value && office.size !== size?.value) {
        return false;
      }
      if (location?.value && office.location?.toLowerCase() !== location?.value?.toLowerCase()) {
        return false;
      }
      if (name && !office.branch?.toLowerCase().includes(name?.toLowerCase())) {
        return false;
      }
      return true;
    });
    setOfficeDetails({ ...OFFICES.current, offices: filteredOffices });
    setSelectedOption(filterOptions[0]);
  };

  const onIsAssignedChange = (option) => {
    setSelectedOption(option);
    setSearchParams({
      city: null,
      size: null,
      location: null,
      address: '',
    });
    let filteredOffices = [];

    switch (option.value) {
      case 'All':
        filteredOffices = OFFICES.current.offices;
        break;
      case 'Assigned':
        filteredOffices = OFFICES.current.offices.filter((item) => !!item.team);
        break;
      case 'Unassigned':
        filteredOffices = OFFICES.current.offices.filter((item) => !item.team);
        break;
      default:
        break;
    }
    setOfficeDetails({ ...OFFICES.current, offices: filteredOffices });
  };

  const onAssignOffice = () => {
    setIsLoading(true);
    base
      .patch(`/operations/offices/${selectedOffice.id}/`, {
        team_id: teamToAssignTo,
      })
      .then((data) => {
        toast.success('Office Assigned Successfully');
        setconfirmOpen(false);
        setTeamsModalOpen(false);
        setTeamToAssignTo('');

        getOffices();
      })
      .catch((err) => {
        toast.error('Error Assigning Office');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const unAssignOffice = () => {
    setIsLoading(true);
    base
      .patch(`/operations/offices/${selectedOffice.id}/`, {
        team_id: null,
        marketer_id: null,
      })
      .then((data) => {
        toast.success('Office Unassigned Successfully');
        getOffices();
        setDetailsOpen(false);
      })
      .catch((err) => {
        toast.error('Error Unassigning Office');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toAssignOffice = (e, office) => {
    e.stopPropagation();
    setSelectedOffice(office);
    setTeamsModalOpen(true);
    if (TEAMS.current.length === 0) {
      setAssignableTeams({ isLoading: true, data: [] });
      base
        .get('/operations/marketing_teams/')
        .then(({ data }) => {
          TEAMS.current = data;
          setAssignableTeams({ isLoading: false, data });
        })
        .catch((err) => {
          setAssignableTeams({ isLoading: false, data: [] });
          toast.error('Could not get teams');
        })
        .finally(() => {
          setAssignableTeams((val) => ({ ...val, isLoading: false }));
        });
    } else {
      setAssignableTeams({ isLoading: false, data: TEAMS.current });
    }
  };

  const onCloseReset = () => {
    setTeamsModalOpen(false);
    setAssignableTeams({ isLoading: false, data: TEAMS.current });
    setTeamToAssignTo('');
  };

  const onAssignTeamSearch = (e) => {
    const value = e.target.value;
    if (value === '') {
      setAssignableTeams({ isLoading: false, data: TEAMS.current });
    } else {
      const filteredTeams = TEAMS.current.filter((team) => team.name.toLowerCase().includes(value.toLowerCase()));
      setAssignableTeams({ isLoading: false, data: filteredTeams });
    }
  };

  const onSave = () => {
    if (teamToAssignTo === '') {
      toast.warn('Please select a team', {
        toastId: 'teamToAssignTo',
      });
      return;
    }
    setconfirmOpen(true);
  };

  const onOpenDetails = (item) => {
    if (!item.team) return;
    setSelectedOffice(item);

    setDetailsOpen(true);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <ConfirmationModal
        hasCloseButton={true}
        open={detailsOpen}
        location={`${selectedOffice?.city}, ${selectedOffice?.state?.toUpperCase()} - ${selectedOffice?.zip_code}`}
        office={selectedOffice?.branch}
        onCancel={() => setDetailsOpen(false)}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <h3>Assignee: {selectedOffice?.team?.name}</h3>
          <Button
            style={{
              width: 'fit-content',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              margin: '0',
            }}
            onClick={unAssignOffice}
            type="submit"
            text="Unassign Office"
          />
          {/* <span>Date assigned</span> */}
        </div>
      </ConfirmationModal>
      <ConfirmationModal
        text={`You are assigning ${selectedOffice?.branch} to the ${
          TEAMS.current.find((item) => item.id === teamToAssignTo)?.name
        }`}
        open={confirmOpen}
        office={selectedOffice?.branch}
        location={selectedOffice?.address}
        onCancel={() => setconfirmOpen(false)}
        onConfirm={onAssignOffice}
      />
      <Modal open={teamsModalOpen} onClose={onCloseReset}>
        <div className="teamsmodal">
          <div className="teamsmodal__header">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h2>{selectedOffice?.branch}</h2>
              <span>{selectedOffice?.address}</span>
            </div>
            <Button
              style={{
                width: '100px',
                fontSize: '18px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
              }}
              onClick={onSave}
              text="Save"
            />

            <CloseIcon className="closer" onClick={onCloseReset} style={{ cursor: 'pointer' }} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '78%',
              margin: '10px auto',
            }}>
            <h2>Teams</h2>
            <Input placeholder="Enter team name" type="search" onChange={onAssignTeamSearch} />
          </div>
          <div className="teamsmodal__content">
            {!assignableTeams.isLoading ? (
              assignableTeams.data?.map(({ id, ...team }) => (
                <TeamBoxHorizontal
                  key={id}
                  onToggle={() => setTeamToAssignTo(id)}
                  {...team}
                  selected={teamToAssignTo === id}
                />
              ))
            ) : (
              <Spinner overlay={false} />
            )}
          </div>
        </div>
      </Modal>
      <div className="officeloc">
        <form className="modinputs" onSubmit={onSearch}>
          <Select
            placeholder="Select City"
            options={CITIES}
            isSearchable={true}
            value={searchParams.city}
            name="city"
            onChange={(e) => onEnterSearch(e, 'city')}
            styles={selectStyles1}
            isClearable={true}
          />
          <Select
            placeholder="Enter Office Size"
            options={sizeOptions}
            value={searchParams.size}
            isSearchable={false}
            name="size"
            onChange={(e) => onEnterSearch(e, 'size')}
            styles={selectStyles1}
            isClearable={true}
          />
          <Select
            placeholder="Enter Office Location"
            options={officeLocations}
            isSearchable={false}
            name="location"
            value={searchParams.location}
            onChange={(e) => onEnterSearch(e, 'location')}
            styles={selectStyles1}
            isClearable={true}
          />
          <Input
            placeholder="Enter Office Address"
            style={{ fontSize: '16px', padding: '10px 20px' }}
            name="address"
            type="search"
            onChange={onEnterSearch}
            value={searchParams.address}
          />

          <Button
            style={{
              width: '100px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            text="Filter"
          />
        </form>
        <div className="ofnav">
          <Select
            isSearchable={false}
            options={filterOptions}
            placeholder="Filter by"
            value={selectedOption}
            onChange={onIsAssignedChange}
            styles={selectStyles}
          />
          <div>
            <Back onClick={() => navigate(-1)} />
            <span>{name}</span>
          </div>
        </div>
        <div className="itemholder">
          {officeDetails?.offices.map((item) => (
            <Item
              name={item.branch}
              key={item.id}
              {...item}
              onClick={() => onOpenDetails(item)}
              onAssignOffice={(e) => toAssignOffice(e, item)}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default AssignOfficeToTeam;

const Item = ({ name, address, marketer_id, onClick, team, onAssignOffice }) => {
  return (
    <div className="item" onClick={onClick} style={{ position: 'relative' }}>
      <p>{name}</p>
      <p>{address}</p>
      {!team && (
        <>
          <MenuDropDown
            activator={
              <BiDotsVerticalRounded
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '10px',
                  cursor: 'pointer',
                }}
                color="var(--primary-color)"
              />
            }>
            <OfficePopUp onAssignOffice={onAssignOffice} />
          </MenuDropDown>
        </>
      )}
    </div>
  );
};

const OfficePopUp = ({ onAssignOffice }) => {
  return (
    <div
      className="office_options"
      style={{
        top: '30%',
        right: '-2%',
        height: 'unset',
        padding: '5px 0',
        width: 'unset',
      }}>
      <div className="reassign_btn" style={{ padding: '10px', fontSize: '14px' }}>
        <span onClick={onAssignOffice}>Assign Office</span>
      </div>
      <div className="reassign_btn" style={{ padding: '10px', fontSize: '14px' }}>
        <span>Delete Office</span>
      </div>
    </div>
  );
};

const TeamBoxHorizontal = ({ selected, onToggle, name, members_count }) => {
  const { color, lighter } = randomColorAndLighter();
  const colors = React.useRef({ color, lighter });
  return (
    <div className="teamboxhorizontal" style={{ backgroundColor: colors.current.lighter }}>
      <TeamLogo color={colors.current.color} style={{ width: '50px', height: '50px ' }} />
      <div className="teamboxhorizontal__names">
        <h5>{name}</h5>
        <span>{members_count}</span>
      </div>
      <div className="agentselection__checker" onClick={onToggle} style={{ marginLeft: 'auto' }}>
        {selected && <AiOutlineCheck color="var(--primary-color)" />}
      </div>
    </div>
  );
};
